export function OverlayIcon({
                                src,
                                width,
                                height = width,
                                alt = "",
                                style,
                                className,
                                ...rest
                            }: {
    src: string
    width?: number
    height?: number
    alt?: string
    style?: React.CSSProperties
} & Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height">) {
    return (
        <span
            className={`relative inline-block shrink-0 ${className ?? ""}`}
            style={{
                ...(width !== undefined ? { width, height } : {}),
                ...style,
            }}
        >
      {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
                {...rest}
                src={src}
                alt={alt}
                width={width}
                height={height}
                style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
            />
      <span
          aria-hidden="true"
          className="absolute inset-0 pointer-events-none"
          style={{
              backgroundColor: "var(--ed-user-header, var(--db-icon-overlay-color, currentColor))",
              opacity: "var(--db-icon-overlay-opacity, 1)",
              WebkitMask: `url(${src}) no-repeat center / contain`,
              mask: `url(${src}) no-repeat center / contain`,
          }}
      />
    </span>
    )
}